/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown> }} Estimated_TotalInputs */



/**
* | output |
* | --- |
* | "Estimated Total: ${cost} USD" |
*
* @param {Estimated_TotalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const estimated_total = /** @type {((inputs: Estimated_TotalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Estimated_TotalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Total estimé : $${i?.cost} USD`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Geschätzter Gesamtbetrag: $${i?.cost} USD`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Totale stimato: $${i?.cost} USD`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ориентировочная общая сумма: $${i?.cost} USD`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Total estimado: $${i?.cost} USD`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`预计总额：$${i?.cost} 美元`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`推定合計金額：$${i?.cost} USD`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अनुमानित कुल राशि: $${i?.cost} USD`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Total estimado: $${i?.cost} USD`)
	return /** @type {LocalizedString} */ (`Estimated Total: $${i?.cost} USD`)
});